export default {
    general: {
        cancel: 'Cancel',
        close: 'Close',
        send: 'Send',
    },
    errors: {
        generic_error: 'An error occurred',
    },
    success: {
        request_sent: 'Thank you — we will call you back shortly.',
    },
    validation: {
        required: 'This field is required',
        phone: 'Enter a valid phone number',
    },
}
